import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class MenuService {

  private menuStateSource = new BehaviorSubject<boolean>(false);
  currentMenuState = this.menuStateSource.asObservable();

  setMenuState(menuState: boolean) {
    this.menuStateSource.next(menuState);
  }

}



// WEBPACK FOOTER //
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/app/services/menu.service.ts